export default __webpack_public_path__ + "static/ubermich-cropped-b47c16ad3a061626f42e35b8498c62c9.jpg";